
export const reportagensDrive = [

  {
    id: 22,
    videoUrl: "https://drive.google.com/file/d/1SWZUS8TPJ2hXSKSN_RMyQTxn7HwNCkt_/preview",
    descricaoVideo: "NE2 - Globo PE - Projeto Conecta Vidas"

  },

  {
    id: 6,
    videoUrl: "https://drive.google.com/file/d/1m_Aafx_3z2yNWk036sfCvcVeG8WVZkL8/preview",
    descricaoVideo: "NE2 - Globo PE - Projeto Passaporte Digital"

  },

  {
    id: 10,
    videoUrl: "https://drive.google.com/file/d/13zySI8wH4pU1Te6ytNdMr0Hs5SwxjA9E/preview",
    descricaoVideo: "NE2 - Globo PE - Inauguração do Centro Tecnológico"

  },

  {
    id: 14,
    videoUrl: "https://drive.google.com/file/d/1X03BXhFIkzNqsOy8Axb_CkrvHrx3m1ln/preview",
    descricaoVideo: "NE2 - Globo PE sobre o Conexão TechFest 2024"

  },

  {
    id: 9,
    videoUrl: "https://drive.google.com/file/d/1f3MCMnNzhfKkBQ4SApFjHO6KbVw6QgXu/preview",
    descricaoVideo: "NE2 - Globo PE - Conexão Social no RecPlay"

  },

  {
    id: 11,
    videoUrl: "https://drive.google.com/file/d/1NU14wklTU4BDtBPkNbvz5E6BrVor1Pcq/preview",
    descricaoVideo: "Bom dia PE - Globo PE reportagem TechFest 2024"

  },

  {
    id: 4,
    videoUrl: "https://drive.google.com/file/d/1-vmMpGk0wuB2EkmyoCk5i7SEvC0LZa6G/preview",
    descricaoVideo: "Bom dia PE - Globo PE anuncia o Conexão TechFest 2024"

  },
  {
    id: 5,
    videoUrl: "https://drive.google.com/file/d/1xp75tlasBs9Keba5DtyG2Wn8HB_MaLob/preview",
    descricaoVideo: "Bom dia PE - Globo PE - Inauguração do Centro Tecnológico"

  },

  {
    id: 7,
    videoUrl: "https://drive.google.com/file/d/18eKK_s0NCrK2OwmR1yLofLOV8nrx49TU/preview",
    descricaoVideo: "Jornal da Globo - Rede Globo - Conexão Social no RecPlay"

  },

  {
    id: 15,
    videoUrl: "https://drive.google.com/file/d/17jc_kaaRacMCrk60VT0gdKvCzuN6XOuU/preview",
    descricaoVideo: "Jornal Nacional - Meninas do Projeto Skate Livre com Rayssa Leal"

  },

  {
    id: 2,
    videoUrl: "https://drive.google.com/file/d/1av7vO08jnlfz2hmHzWx9aOuLncGTz4qg/preview",
    descricaoVideo: "TECHFEST 2025 TVPE"

  },

  {
    id: 0,
    videoUrl: "https://drive.google.com/file/d/15BHzryprR2OKkDEK8Wr8XmYhMCa_gziT/preview",
    descricaoVideo: "Skate Livre NeoEnergia"

  },
  {
    id: 1,
    videoUrl: "https://drive.google.com/file/d/1cK4rw4rU2ACszNzlEexUn_wc4_z_O5N2/preview",
    descricaoVideo: "Lei de Incentivo ao Esporte"

  },

  {
    id: 3,
    videoUrl: "https://drive.google.com/file/d/1qReVl7wFeTUyXqTpRWfhgx0IgNetyOBu/preview",
    descricaoVideo: "TV JORNAL TECH FEST 2025"

  },

  {
    id: 8,
    videoUrl: "https://drive.google.com/file/d/18CB3avY6qgivm0IS89tzptQ1HTFxcqHL/preview",
    descricaoVideo: "Tudo Aqui - Tv Jornal sobre o Conexão TechFest 2024"

  },

  {
    id: 12,
    videoUrl: "https://drive.google.com/file/d/1L7IPHqcJD2IL7cK1eMWvSe6NBhk5HkTa/preview",
    descricaoVideo: "TV Pernambuco - TV Brasil - História da Conexão Social"

  },
  {
    id: 13,
    videoUrl: "https://drive.google.com/file/d/1SmuIAvPuK6bkTlOdyutoq9FLuG59mpKJ/preview",
    descricaoVideo: "TV Pernambuco - TV Brasil - Conexão Social"

  },


  {
    id: 16,
    videoUrl: "https://drive.google.com/file/d/1h3wS2VRgAizIZdECdr9BhELhKQCfWmdf/preview",
    descricaoVideo: "Declare proteção a criança TJPE"

  },
  {
    id: 17,
    videoUrl: "https://drive.google.com/file/d/1A7q6u01_dSzg2KJz4MNQ9Ui6aDLUaYYb/preview",
    descricaoVideo: "O POVO NA TV TJPE - Campanha de Apoio à Infância"

  },
  {
    id: 18,
    videoUrl: "https://drive.google.com/file/d/1zwsQ_XMWPqMsZVboHC3moDc_dlm4D61z/preview",
    descricaoVideo: "PRIMEIRO IMPACTO PE TJPE - Declare proteção à infância"

  },
  {
    id: 19,
    videoUrl: "https://drive.google.com/file/d/1i5O4GV4U-_2OEy_RtDaf8JQlk6mmzKKK/preview",
    descricaoVideo: "TJPE e Receita Federal lançam campanha"

  },
  {
    id: 20,
    videoUrl: "https://drive.google.com/file/d/18oDzoVHH_tCtBbkhp5kS8Azj8mQipSYn/preview",
    descricaoVideo: "TJPE faz campanha para beneficiar programas de proteção à infância NETV 2"

  },
  {
    id: 21,
    videoUrl: "https://drive.google.com/file/d/1aj_eySbEqOwP5uv2Y14FtmDiZ1yTiEME/preview",
    descricaoVideo: "VAMOSIMBORA? NeoEnergia"

  },
  {
    id: 30,
    videoUrl: "https://drive.google.com/file/d/1p13-W6hJAxPT5G7fEzEifHvmqylHnI4X/preview",
    descricaoVideo: "Depoimento Aluna Passaporte Digital"

  }



];

